import { render, staticRenderFns } from "./V2CollectionEdit.vue?vue&type=template&id=73525adb&scoped=true&"
import script from "./V2CollectionEdit.vue?vue&type=script&lang=js&"
export * from "./V2CollectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./V2CollectionEdit.vue?vue&type=style&index=0&id=73525adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73525adb",
  null
  
)

export default component.exports